import { Position } from '#src/__generated__/globalTypes.ts';
import { BaseballCatcher } from '#src/assets/icons/BaseballCatcher.tsx';
import { BaseballCornerInfielder } from '#src/assets/icons/BaseballCornerInfielder.tsx';
import { BaseballDesignatedHitter } from '#src/assets/icons/BaseballDesignatedHitter.tsx';
import { BaseballFirstBase } from '#src/assets/icons/BaseballFirstBase.tsx';
import { BaseballFlex } from '#src/assets/icons/BaseballFlex.tsx';
import { BaseballHitter } from '#src/assets/icons/BaseballHitter.tsx';
import { BaseballMiddleInfielder } from '#src/assets/icons/BaseballMiddleInfielder.tsx';
import { BaseballOutfielder } from '#src/assets/icons/BaseballOutfielder.tsx';
import { BaseballReliefPitcher } from '#src/assets/icons/BaseballReliefPitcher.tsx';
import { BaseballSecondBase } from '#src/assets/icons/BaseballSecondBase.tsx';
import { BaseballShortStop } from '#src/assets/icons/BaseballShortStop.tsx';
import { BaseballStartingPitcher } from '#src/assets/icons/BaseballStartingPitcher.tsx';
import { BaseballThirdBase } from '#src/assets/icons/BaseballThirdBase.tsx';
import { DefaultPosition } from '#src/assets/icons/DefaultPosition.tsx';
import { anyBaseballPositions, anyHitterPositions } from '#src/lib/baseball.ts';
import type { unitMapping } from '#src/lib/style.ts';

const mapKey = (positions: Nullable<Position>[]) =>
  [...(positions || [])].sort().join(',');

const knownSlots = {
  [mapKey([Position.baseball_starting_pitcher])]: BaseballStartingPitcher,
  [mapKey([Position.baseball_relief_pitcher])]: BaseballReliefPitcher,
  [mapKey([Position.baseball_first_base])]: BaseballFirstBase,
  [mapKey([Position.baseball_second_base])]: BaseballSecondBase,
  [mapKey([Position.baseball_third_base])]: BaseballThirdBase,
  [mapKey([Position.baseball_designated_hitter])]: BaseballDesignatedHitter,
  [mapKey([Position.baseball_catcher])]: BaseballCatcher,
  [mapKey([Position.baseball_shortstop])]: BaseballShortStop,
  [mapKey([
    Position.baseball_first_base,
    Position.baseball_third_base,
    Position.baseball_designated_hitter,
  ])]: BaseballCornerInfielder,
  [mapKey([
    Position.baseball_second_base,
    Position.baseball_shortstop,
    Position.baseball_catcher,
  ])]: BaseballMiddleInfielder,
  [mapKey([Position.baseball_outfield])]: BaseballOutfielder,
  [mapKey(anyHitterPositions)]: BaseballHitter,
  [mapKey(anyBaseballPositions)]: BaseballFlex,
};

type Props = {
  positions: Nullable<Position>[];
  size?: keyof typeof unitMapping;
};

export const BaseballIcon = ({ positions, size }: Props) => {
  const positionKey = mapKey(positions);
  const Icon = knownSlots[positionKey] ?? DefaultPosition;

  return <Icon size={size} />;
};
